export default __webpack_public_path__ + "static/media/a036-3.c7fc0076.svg";